import React from 'react'
import { useAnalytics } from '../hooks/useAnalytics'

/**
 * Headless component to track analytics events on route change.
 * Must be rendered inside a Router.
 */
export const AnalyticsTracker: React.FC = () => {
  useAnalytics()
  return null
}
















